// extracted by mini-css-extract-plugin
module.exports = {"sub":"Navigation_sub__UJn5_","separator":"Navigation_separator__19-ak","link":"Navigation_link__od0gj"};